<template>
  <div class="main">
    <van-radio-group direction="horizontal" v-bind="$attrs" v-on="$listeners">
      <van-radio v-for="item in options" :name="item.value" :key="item.value">{{ item.label }}</van-radio>
    </van-radio-group>
  </div>

</template>

<script>
import { getDictListTime } from '@/utils/getDictDataList.js'
export default {
  name: "ct-radio",
  props: {
    codeType: String,
  },
  data() {
    return {
      options: []
    }
  },
  // async created() {
  //
  // },
  mounted() {
    getDictListTime(this.codeType).then(res => {
      if (!res) {
        this.options = [{
          value: "0",
          label: "无字典数据"
        }]
      }
      else {
        this.options = res
      }
    })
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.van-radio-group--horizontal{
  gap: 10px;
}
</style>
